import Typography from '@ixigo/iui/Typography';
import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { getWidgetBySnapshotId } from '../../apis/conversation';
import { StepColor, StepType } from '../../enums/widget';
import TypingLoader from '../Loader/Typing';
import MessageBubble from '../MessageBubble';
import Timeline from '../Timeline';
import { TimelineProps } from '../Timeline/index.types';
import { WidgetProps } from './index.types';

function RefundTimeline({ message, widgetData }: Omit<WidgetProps, 'isLastMessage'>) {
    const { actor } = message;

    const { snapshotId } = widgetData.parameters;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [data, setData] = useState<TimelineProps['data'][]>([]);

    useEffect(() => {
        getWidgetBySnapshotId(snapshotId as string, 'JSON')
            .then((timelineData) => {
                setData(
                    timelineData.map((item) => {
                        const isRefundDelayed =
                            item.refundTimelines.some((step) => step.className.startsWith('delayed')) ||
                            item.isRefundDelayed;

                        return {
                            isRefundSuccessful: item.isRefundSuccessful,
                            steps: item.refundTimelines.map((step) => {
                                const { arn, subText, text } = step;
                                let color = StepColor.SUCCESS;
                                let type = StepType.PAST;

                                if (step.className.startsWith('delayed')) {
                                    color = StepColor.WARN;
                                    type = StepType.PRESENT;
                                } else if (step.className.startsWith('pending')) type = StepType.FUTURE;

                                if (!isRefundDelayed && step.className.includes('current')) type = StepType.PRESENT;

                                return { arn, color, subText, text, type };
                            }),
                            sources: item.refundSources,
                        };
                    }),
                );
            })
            .catch(() => {
                setError('Something went wrong while fetching refund details.');
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    if (error)
        return (
            <MessageBubble actor={actor}>
                <Typography variant='body-md'>{error}</Typography>
            </MessageBubble>
        );

    if (loading)
        return (
            <MessageBubble actor={actor}>
                <TypingLoader />
            </MessageBubble>
        );

    return data.map((item) => (
        <MessageBubble actor={actor} key={uuidv4()}>
            <Timeline data={item} defaultCollapsed={item.isRefundSuccessful} />
        </MessageBubble>
    ));
}

export default RefundTimeline;
